export enum ChangeType {
    Created = 'created',
    Status = 'status',
    Assign = 'assign',
    Multiple = 'multiple'
}
